import React, { forwardRef, PropsWithChildren } from "react";

import { StyledIconButton } from "./Styles";
import { ButtonProps } from "../Button";

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface IconButtonProps extends ButtonProps {}

/**
 * @component IconButton
 * @description
 * IconButton composes the Button component except that it renders only an icon.
 * Since IconButton only renders an icon, you have to pass the aria-label prop,
 * so screen readers can give meaning to the button.
 *
 * @props See Button props.
 *
 * @example
 * return (
 *   <IconButton className="mr-2" variant="primary" size="medium" aria-label="Close dialog">
 *     <CloseIcon />
 *   </IconButton>
 * )
 * @see
 * https://system.activecollab.com/?path=/story/components-button-indicators-button--icon-button
 * https://design.activecollab.com/docs/components/button
 */

export const IconButton = forwardRef<
  HTMLButtonElement,
  PropsWithChildren<IconButtonProps>
>(({ children, className, variant, size, active, ...args }, ref) => {
  return (
    <StyledIconButton
      className={className}
      variant={variant}
      size={size}
      active={active}
      ref={ref}
      {...args}
    >
      {children}
    </StyledIconButton>
  );
});

IconButton.displayName = "IconButton";
